var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6065 35.6414C14.7169 35.7577 14.851 35.8496 14.9999 35.9111C15.1488 35.9727 15.3092 36.0025 15.4706 35.9986C15.6325 36.0069 15.7942 35.9791 15.9438 35.9173C16.0934 35.8554 16.227 35.7612 16.3346 35.6414L26.0638 25.8272C28.9001 22.9762 30.4925 19.1423 30.4997 15.1466C30.507 11.151 28.9286 7.31138 26.1027 4.45038C24.7578 3.07434 23.1514 1.97328 21.3753 1.21008C19.5991 0.446871 17.6881 0.0364766 15.7513 0.00232297C13.8145 -0.0318306 11.8898 0.310919 10.0872 1.01102C8.28463 1.71112 6.63947 2.75484 5.24558 4.08259C5.13757 4.18919 5.02093 4.2958 4.91076 4.41093C2.0889 7.2773 0.507037 11.1146 0.499781 15.1113C0.492525 19.108 2.06044 22.9509 4.87186 25.8272L14.6065 35.6414Z",
    fill: "#492897"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51166 10.5544C9.8703 10.1957 10.4518 10.1957 10.8104 10.5544L15.6712 15.4152L20.5321 10.5544C20.8907 10.1957 21.4722 10.1957 21.8308 10.5544C22.1895 10.913 22.1895 11.4945 21.8308 11.8532L16.3206 17.3634C15.962 17.722 15.3805 17.722 15.0219 17.3634L9.51166 11.8532C9.15301 11.4945 9.15301 10.913 9.51166 10.5544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerPurple);
export default __webpack_public_path__ + "static/media/marker-purple.0cc8ae5fa8f4974ebedf787fa3a5d57d.svg";
export { ForwardRef as ReactComponent };